import { WorkingPlacesResponseDataType } from '../../../types/Admin/WorkingPlacesTypes';

const DEFAULT_BRANCH = "default";
const defaultLower = DEFAULT_BRANCH.toLowerCase();

const filterDefaultBranches = (branches?: { id: number; name: string }[]) =>
  branches?.filter(
    (b) => b.id !== 0 && b.name.trim().toLowerCase() !== defaultLower,
  );

export const modifyWorkingPlacesData = (arr: WorkingPlacesResponseDataType[]) => {
  return arr.map((item) => {
    const {
      description,
      id,
      isActive,
      officeNumber,
      users,
      windowNumber,
      digitalDisplayIp,
      type,
      topics,
      branchName,
      queueName,
      branches,
      queues
    } = item;
    const normalizedQueues = queues ?? null;
    const hasQueuesField = normalizedQueues !== null;
    const hasAnyQueues = (queues?.length ?? 0) > 0;
    const shouldHideBranchName =
      (branches || []).some(
        (b) => b.id === 0 || b.name.trim().toLowerCase() === defaultLower,
      );

    // Если бэкенд вернул поле queues и оно пустое — рабочее место больше не привязано ни к одной очереди.
    // В таком случае списки users/topics могут оставаться "старыми" (или вычисленными через удалённую очередь),
    // поэтому считаем их недействительными и очищаем, чтобы UI показывал прочерк.
    const effectiveUsers = hasQueuesField && !hasAnyQueues ? [] : users;
    const effectiveTopics = hasQueuesField && !hasAnyQueues ? [] : topics;
    return {
      id,
      workingPlace: description,
      cabinet: officeNumber || null,
      number: windowNumber || null,
      assignedEmployees: effectiveUsers,
      boardIp: digitalDisplayIp || '',
      assignedServices:
        effectiveTopics?.map((e) => {
          return {
            id: e.id,
            nameRu: e.name
          };
        }) || [],
      type,
      isActive,
      branchName: shouldHideBranchName ? '' : branchName || '',
      // Если поле queues присутствует, считаем его источником истины.
      // При удалённой очереди бэкенд может оставлять старое queueName, но queues будет пустым.
      // В таком случае очищаем queueName, чтобы UI показал прочерк.
      queueName: normalizedQueues === null ? (queueName || '') : '',
      branches: filterDefaultBranches(branches) || [],
      queues: queues || []
    };
  });
};
